module.exports = __webpack_public_path__ + "img/admin1.c95e7c69.png";